import { slugify } from "@certn/utils";
import { parseDate } from "@internationalized/date";
import { useJsonForms } from "@jsonforms/react";
import get from "lodash.get";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { DateFieldControl } from "./DateFieldControl";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

function EndDateControl(props: CascadiaControlProps) {
  const { t } = useTranslation();
  const context = useJsonForms();

  const options = props.uischema?.options || {};
  const startDate = get(context?.core?.data, options?.minDateFieldName);

  const [endDateAfterStartDateError, setEndDateAfterStartDateError] = useState<
    string | null
  >(null);

  return (
    <>
      {!context?.core?.data?.[options?.current_field_name] && (
        <DateFieldControl
          {...props}
          required
          minValue={startDate && parseDate(startDate)}
          validate={(value) => {
            if (!value) {
              return `${props.label} ${t("is a required field")}`;
            }
            if (startDate && parseDate(startDate) > value) {
              setEndDateAfterStartDateError(
                `${props.label} ${t("must be after the start date")}`
              );
              return;
            }
            setEndDateAfterStartDateError(null);
            return undefined;
          }}
          errors={[...props.errors, endDateAfterStartDateError ?? ""]}
          data-testid={`address-history-${slugify(props.path)}-input`}
        />
      )}
    </>
  );
}

export const EndDateControlRenderer = withCascadiaControlProps(EndDateControl);
